
import { Options, Vue } from "vue-class-component";
@Options({})
export default class Footer extends Vue {
  Pin = "";
}
